import {User} from "@/data/entities/user";
import router, {Route} from "@/routing/Router";
import {getDashboardRole} from "@/data/entities/user/utils";


export const getHomeHref = (user: User): string => getHomeRoute(user).absolutePath();

export const getHomeRoute = (user: User): Route => {
    switch (getDashboardRole(user)) {
        case "ROLE_ADMIN":
            return router.adminHome;
        case "ROLE_POS":
            return router.posAdminDashboardHome;
    }

    throw Error("Insufficient rights")
};